// Kota besar Indonesia untuk saran autocomplete (tetap boleh tulis sendiri).
export const INDONESIAN_CITIES = [
  "Jakarta",
  "Bogor",
  "Depok",
  "Tangerang",
  "Tangerang Selatan",
  "Bekasi",
  "Bandung",
  "Cirebon",
  "Semarang",
  "Solo",
  "Yogyakarta",
  "Surabaya",
  "Malang",
  "Denpasar",
  "Mataram",
  "Kupang",
  "Medan",
  "Padang",
  "Pekanbaru",
  "Jambi",
  "Palembang",
  "Bengkulu",
  "Bandar Lampung",
  "Banda Aceh",
  "Batam",
  "Pontianak",
  "Palangka Raya",
  "Banjarmasin",
  "Balikpapan",
  "Samarinda",
  "Makassar",
  "Manado",
  "Palu",
  "Kendari",
  "Ambon",
  "Jayapura",
];
